export enum ReportType {
  INITIAL = "initial",
  FOLLOW_UP = "followUp",
  INITIAL_ORTHO_EXTREMITIES = "initialOrthoExtremities",
  FOLLOW_UP_ORTHO_EXTREMITIES = "followUpOrthoExtremities",
}

export type ServerReportType =
  | "npp"
  | "npp_ortho_spine"
  | "npp_ortho_extremities"
  | "npp_primary_care"
  | "followup"
  | "followup_ortho_spine"
  | "followup_ortho_extremities"
  | "followup_primary_care"
  | "reeval"
  | "reeval_ortho_spine"
  | "reeval_ortho_extremities";
